import { title } from "process";
import { CartCategoryItem } from "../../types/cartTypes";

export const BEHALF_USER_SYSAID_KEY = "CustomColumn141sr";


export const addBehalfUserToSysAidPayload = (
  sysAidPayload: { info: { key: string; value: any }[] },
  behalfOfUserName?: string | null
) => {
  const name = behalfOfUserName?.trim();
  if (!name) return;
  sysAidPayload.info = sysAidPayload.info.filter(
    (entry) => entry.key !== BEHALF_USER_SYSAID_KEY
  );
  sysAidPayload.info.push({ key: BEHALF_USER_SYSAID_KEY, value: name });
};

export const processRequestItems = (
  items: CartCategoryItem[],
  createdUserEmail: string,
  createdUserName: string,
  behalfOfUserName?: string | null
) => {
  let ItemsWithGeneralHardwareRequest: any[] = [];
  let ItemsWithoutGeneralHardwareRequest: any[] = [];
  let new_description = "";

  if (items && items.length > 0) {
    items.forEach((item: any) => {
      if (
        item.catagoryItemsform &&
        (item.catagoryItemsform.formName === "General Hardware Request" ||
          item.catagoryItemsform.templateID === "3476")
      ) {
        ItemsWithGeneralHardwareRequest.push(item);
      } else {
        ItemsWithoutGeneralHardwareRequest.push(item);
      }
    });
  }

  if (ItemsWithoutGeneralHardwareRequest.length > 0) {
    ItemsWithoutGeneralHardwareRequest.forEach((item: any) => {
      let problemTypeValue = "";
      switch (item.category.id) {
        case 1:
          problemTypeValue = "Hardware Request";
          break;
        case 2:
          problemTypeValue = "Software Request_New Software";
          break;
        case 4:
          problemTypeValue = "Employee Lifecycle";
          break;
      }

      const numWeeks = 2;
      const dueDate = new Date();
      dueDate.setDate(dueDate.getDate() + numWeeks * 7);

      // sysAidPayload: {
      //   info: {
      //     key: string;
      //     value: string;
      //   }[];
      // }

      let descriptionValue = item.description;
      if (item.category.id === 2 && item.formData) {
        try {
          const formDataObj = JSON.parse(item.formData);
          if (formDataObj && formDataObj["Details"]) {
            descriptionValue = formDataObj["Details"] + "\nRequest User: " + createdUserName + (behalfOfUserName ? "\nBehalf of User: " + behalfOfUserName : "");
          }
        } catch {}
      }
      const sysAidPayload = {
        info: [
          { key: "due_date", value: dueDate.getTime().toString() },
          { key: "status", value: "2" },
          { key: "problem_type", value: problemTypeValue },
          { key: "description", value: descriptionValue },
          { key: "CustomColumn93sr", value: createdUserName },
          { key: "request_user_name", value: createdUserName },
          { key: "notes", value: [] },
        ],
      };
      if (item.category.id === 2) {
        sysAidPayload.info.push({ key: "title", value: item.description });
      }

      if (item.formData) {
        const formDataValue = JSON.parse(item.formData);
        const formDataEntries = Object.entries(formDataValue).map(
          ([key, value]) => ({ key, value })
        );

        if (item.sysAidTemplateId) {
          sysAidPayload.info.push(...formDataEntries);
        }
      }

      addBehalfUserToSysAidPayload(sysAidPayload, behalfOfUserName);

      item.SysAidDetails = {
        sysAidPayload: JSON.stringify(sysAidPayload),
        sysAidTemplateId: item.sysAidTemplateId,
      };
    });
  }

  if (ItemsWithGeneralHardwareRequest.length > 0) {
    new_description = ItemsWithGeneralHardwareRequest.map(
      (item) => item.description
    ).join(", ");

    ItemsWithGeneralHardwareRequest.forEach((item: any) => {
      const problemTypeValue = "Hardware Request";

      const numWeeks = 2;
      const dueDate = new Date();
      dueDate.setDate(dueDate.getDate() + numWeeks * 7);

      const sysAidPayload: any = {
        info: [
          { key: "due_date", value: dueDate.getTime().toString() },
          { key: "status", value: "2" },
          { key: "problem_type", value: problemTypeValue },
          { key: "description", value: new_description },
          { key: "CustomColumn93sr", value: createdUserName },
          { key: "request_user_name", value: createdUserName },
          { key: "notes", value: [] },
        ],
      };

      if (item.formData) {
        const formDataValue = JSON.parse(item.formData);
        const formDataEntries = Object.entries(formDataValue).map(
          ([key, value]) => ({ key, value })
        );

        if (item.sysAidTemplateId) {
          sysAidPayload.info.push(...formDataEntries);
        }
      }

      addBehalfUserToSysAidPayload(sysAidPayload, behalfOfUserName);

      item.SysAidDetails = {
        sysAidPayload: JSON.stringify(sysAidPayload),
        sysAidTemplateId: item.sysAidTemplateId,
      };
    });
  }

  return {
    processedItems: items,
    ItemsWithGeneralHardwareRequest,
    ItemsWithoutGeneralHardwareRequest,
  };
};
